export default __webpack_public_path__ + "static/media/nli-logo-gray-500.0a46d5bc.svg";